import { render, staticRenderFns } from "./rightMiddle.vue?vue&type=template&id=9040467c&"
import script from "./rightMiddle.vue?vue&type=script&lang=js&"
export * from "./rightMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports